import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private readonly router: Router) { }

  ngOnInit() {
  }
  public dateTime=new Date().getFullYear();

  public footerPostion(): boolean {
    const footerPos = this.router.isActive(
      this.router.parseUrl("/recognition"),
      false
    );
    const footerPosSubmit = this.router.isActive(
      this.router.parseUrl("innovations/submit"),
      false
    );
    if (footerPos || footerPosSubmit) {
      return true;
    }
     else {
      return false;
    }
  }

}
